/** Expenses domain API — pure types and functions with zero deps on infra/app/ui. */
export type {
  ExpenseRow,
  ExpenseCategoryRow,
  ExpenseSettlementRow,
  ExpenseSettlementListRow,
  ExpenseSettlementsListResult,
  ExpenseSettlementsSummary,
  ExpenseSettlementMethod,
  ExpensesSummary,
  ProfitLossSummary,
  ExpenseListQuery,
  ExpenseListSummary,
  ExpensePaymentStatusFilter,
  ExpenseDueStatusFilter,
  ExpenseSortBy,
  ExpenseSettlementsListQuery,
  LinkedPurchaseExpenseRow,
  ExpenseAttachmentRow,
  ExpenseFiscalInvoiceInput,
} from './domain/expenseTypes';

export {
  PURCHASE_DOC_TYPES,
  creditNoteDocTypeFromPurchaseInvoice,
  docTypeDiscriminatesIva,
  emptyExpenseFiscalDraft,
  expenseFiscalDraftIsEmpty,
  expenseFiscalDraftToInput,
  expenseFiscalDraftTotal,
  expenseFiscalRowToDraft,
  isCreditNoteDocType,
  purchaseDocType,
  purchaseDocTypeLabel,
  validateExpenseFiscalInvoice,
  type ExpenseFiscalDraft,
} from './domain/expenseFiscalInvoice';

export {
  DEFAULT_EXPENSE_CATEGORY_SLUGS,
  EXPENSE_CATEGORY_LABELS,
  type ExpenseCategorySlug,
} from './domain/expenseCategories';

export {
  formatExpenseMoney,
  expensePaymentStatusLabel,
  expenseSettlementMethodLabel,
  expenseSettlementStatusLabel,
  expenseAmountResidual,
} from './domain/expenseLabels';

export { expenseErpCopy } from './domain/expenseErpCopy';
